import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'

import { Button } from '@/components/ui/button'

export const Forbidden = () => {
  const { t } = useTranslation('common')

  return (
    <main className="flex min-h-screen items-center justify-center p-6">
      <section className="text-center">
        <h1 className="text-2xl font-semibold">403</h1>
        <p className="mt-2 text-sm text-muted-foreground">{t('forbidden')}</p>
        <Button className="mt-4" asChild>
          <Link to="/workbench">{t('return_workbench')}</Link>
        </Button>
      </section>
    </main>
  )
}
